/* eslint-disable indent */
import {
  Box,
  FormLabel,
  FormControl,
  Checkbox,
  Grid,
  Input,
  NativeSelect,
  Paper,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
} from '@material-ui/core';
import React, { useState, useEffect, useRef } from 'react';
import InputMask from 'react-input-mask';
import { toast } from 'react-toastify';
import ReactCodeInput from 'react-verification-code-input';
import { useMessageBox } from '../../../context/MessageBox';
import api from '../../../services/api';
import { handleErrorRequest } from '../../../utils/errorsValidation';
import * as S from './styles';


const statusRural = {
  Nao: false,
  Sim: true,
};

const ApproveConclusion = ({ data, setResponseMessage }) => {
  const [rural, setRural] = useState('false');
  const [boleto, setBoleto] = useState('');
  const [abatimentos, setAbatimentos] = useState('');
  const { setMessageData } = useMessageBox();
  const [code, setCode] = useState('');
  const [formValues, setFormValues] = useState({});
  const [getErros, setErros] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [bancoDefault, setBancoDefault] = useState('')
  const [dadoRecebido, setDadoRecebido] = useState(data);

  const onChange = (event) => {
    setCode(event);
  };

  const saveForm = async (formData) => {
    setIsLoading(true);
    try {
      const response = await api.put('OperacoesAntecipacoes/ConcluirAntecipacao', formData);
      setMessageData(response.data.complemento?.mensagensBox);
      if (response.data.resposta.sucesso) {
        toast.success('Proposta aceita com sucesso!');
        setResponseMessage(response.data.resposta.mensagem);
      }
      if (response.data.status === 'Inconsistencia') {
        setErros(handleErrorRequest(response));
      }
    } catch (error) {
      handleErrorRequest(error.response);
    }
    setIsLoading(false);
  };

  const submitForm = async () => {
    if (dadoRecebido.solicitarCodigoAutenticacao && code.length < 4) {
      return toast.error('Campo autenticação obrigatório!');
    }
    if (
      dadoRecebido.solicitarContaBancaria &&
      rural === 'false' &&
      formValues.bancoId !== '999999' &&
      (formValues.bancoId === 0 ||
        !formValues.bancoId ||
        formValues.agencia === '' ||
        formValues.conta === '' ||
        formValues.contaDigito === '' ||
        formValues.filialCNPJ === '')
    ) {
      return toast.error('Preencha as informações de pagamento!');
    }
    if (dadoRecebido.gruposFornecedores?.tipoPessoa === 'Juridica' && formValues.filialCNPJ === '') {
      return toast.error('Preencha CNPJ!');
    }
    let cpfCnpj;
    if (dadoRecebido.gruposFornecedores?.tipoPessoa === 'Juridica') {
      cpfCnpj = formValues?.filialCNPJ
        ? `${dadoRecebido.gruposFornecedores?.raizCnpjCpf}/${formValues?.filialCNPJ}`
        : dadoRecebido.cnpjComplemento === ''
          ? `${dadoRecebido.gruposFornecedores?.raizCnpjCpf}`
          : `${dadoRecebido.gruposFornecedores?.raizCnpjCpf}/${dadoRecebido.cnpjComplemento}`;
    }
    if (dadoRecebido.gruposFornecedores?.tipoPessoa === 'Fisica') {
      cpfCnpj = formValues?.cpfCnpj || dadoRecebido.gruposFornecedores?.raizCnpjCpf;
    }

    const formData = {
      antecipacaoId: dadoRecebido.antecipacaoId,
      ancoraId: dadoRecebido.ancoraId,
      antecipacaoCodigoAutenticacaoId: dadoRecebido.antecipacaoCodigoAutenticacaoId,
      fornecedorId: dadoRecebido.fornecedorId,
      fornecedorContaBancariaId: dadoRecebido.fornecedorContaBancariaId,
      dataAtualizacao: dadoRecebido.dataAtualizacao,
      codigoAutenticacaoDigitado: code || '0000',
      conclusao: dadoRecebido.conclusao,
      respostaDoFornecedor: '',
      produtorRural: rural === 'true',
      fornecedoresContasBancarias: {
        agencia: formValues.agencia || dadoRecebido.agencia || '',
        agenciaDigito: dadoRecebido.obrigaDigitoAgencia == "Sim" ? formValues.agenciaDigito : '',
        ancoraId: dadoRecebido.ancoraId,
        bancoId: Number(formValues.bancoId || dadoRecebido.fornecedorContaBancariaId),
        cnpjCpf: cpfCnpj,
        conta: formValues.conta || dadoRecebido.conta || '',
        contaDigito: formValues.contaDigito ? formValues.contaDigito.toUpperCase() : '',
        fornecedorId: dadoRecebido.fornecedorId,
        status: 'Ativo',
      },
      antecipacaoMotivoRecusaId: 0,
      boletosEmitidos: boleto,
      aceitaAbatimentosDescontos: abatimentos,
      origemAprovacao: dadoRecebido.origemAprovacao
    };
    saveForm(formData);
  };

  useEffect(() => {
    if (
      dadoRecebido.questionarFornecedoresBoletosEmitidos.toLowerCase() === 'nao' ||
      dadoRecebido.questionarFornecedoresBoletosEmitidos === 0
    ) {
      setBoleto('NaoSeAplica');
    }
    setAbatimentos('NaoSeAplica')
    if (dadoRecebido.solicitarContaBancaria && dadoRecebido.bancos && dadoRecebido.bancos.length > 0) {
      const bancoIdDefault = dadoRecebido.bancos[0].bancoId.toString()
      setBancoDefault(bancoIdDefault)
      setFormValues((prev) => ({ ...prev, bancoId: bancoIdDefault }));
    }

    setDadoRecebido(data);

    console.log('recebido dado para abaixo')
    console.log(typeof data.solicitarCodigoAutenticacao)
    console.log(data.solicitarCodigoAutenticacao)
    console.log(data)

  }, [data]);

  return (
    
      <div>
        {dadoRecebido.solicitarContaBancaria && (
          <S.InfoContainer>
            <S.TableTitleHeader>
              <h1>Dados Bancários</h1>
            </S.TableTitleHeader>
            <div style={{ padding: '0px 10px' }}>
              <FormControl>
                <S.InputLabel>Produtor Rural?</S.InputLabel>
                <RadioGroup
                  row
                  value={rural}
                  onChange={(e) => {
                    setRural(e.target.value);
                    if (e.target.value === 'true') {
                      setFormValues({});
                    } else {
                      setFormValues((prev) => ({ ...prev, bancoId: bancoDefault }));
                    }
                  }}
                >
                  <FormControlLabel value="true" control={<Radio />} label="Sim" />
                  <FormControlLabel value="false" control={<Radio />} label="Não" />
                </RadioGroup>
              </FormControl>
              <S.ApproveContainer>
                {rural === 'false' ? (
                  <>
                    <Grid container spacing={2}>
                      <Grid item xs={8}>
                        <S.InputLabel>Banco</S.InputLabel>
                        <Paper elevation={0} className="input-paper">
                          <NativeSelect
                            className="input-select"
                            disableUnderline
                            onChange={(e) => {
                              if (e.target.value !== '999999') {
                                return setFormValues((prev) => ({ ...prev, bancoId: e.target.value }));
                              }
                              setFormValues((prev) => ({
                                ...prev,
                                bancoId: e.target.value,
                                agenciaDigito: '',
                                agencia: '',
                                conta: '',
                                contaDigito: '',
                              }));
                            }}
                          >
                            {dadoRecebido.bancos?.map((bank) => (
                              <option key={bank.bancoId} value={bank.bancoId}>
                                {bank.banco}
                              </option>
                            ))}
                          </NativeSelect>
                        </Paper>
                      </Grid>
                    </Grid>

                    {formValues.bancoId !== '999999' && (
                      <>
                        <Grid container spacing={2}>
                          <Grid item xs={3}>
                            <S.InputLabel>Agência</S.InputLabel>
                            <Paper elevation={0} className="input-paper">
                              <InputMask
                                mask="9999"
                                value={formValues?.agencia || dadoRecebido.agencia}
                                name="agencia"
                                onChange={(e) => {
                                  setFormValues((prev) => ({ ...prev, agencia: e.target.value }));
                                }}
                                error={getErros.includes('Agencia')}
                                onBlur={() => {
                                  if (!formValues?.agencia && !dadoRecebido.agencia) {
                                    setErros((prev) => [...prev, 'Agencia']);
                                  } else {
                                    getErros.includes('Agencia') &&
                                      setErros(getErros.filter((item) => item !== 'Agencia'));
                                  }
                                }}
                              >
                                {() => (
                                  <Input
                                    placeholder="Agência"
                                    className="input-select"
                                    name="agencia"
                                    style={{ height: '42px' }}
                                  />
                                )}
                              </InputMask>
                            </Paper>
                          </Grid>
                          {dadoRecebido.obrigaDigitoAgencia == 'Sim' && (
                            <Grid item xs={1}>
                              <S.InputLabel>Dígito</S.InputLabel>
                              <Paper elevation={0} className="input-paper">
                                <Input
                                  className="input-select"
                                  placeholder="Dígito"
                                  maxLength={1}
                                  onChange={(e) => {
                                    setFormValues((prevValues) => ({
                                      ...prevValues,
                                      agenciaDigito: e.target.value,
                                    }));
                                  }}
                                  value={formValues?.agenciaDigito}
                                  name="agenciaDigito"
                                  inputProps={{
                                    minLength: 1,
                                    maxLength: 1,
                                    style: { textTransform: "uppercase" }
                                  }}
                                  error={getErros.includes('agenciaDigito')}
                                  onBlur={() => {
                                    if (!formValues?.agenciaDigito && !dadoRecebido.agenciaDigito) {
                                      setErros((prev) => [...prev, 'agenciaDigito']);
                                    } else {
                                      getErros.includes('agenciaDigito') &&
                                        setErros(getErros.filter((item) => item !== 'agenciaDigito'));
                                    }
                                  }}
                                />
                              </Paper>
                            </Grid>
                          )}
                          <Grid item xs={dadoRecebido.obrigaDigitoAgencia == 'Sim' ? 3 : 4}>
                            <S.InputLabel>Conta</S.InputLabel>
                            <Paper elevation={0} className="input-paper">
                              <Input
                                className="input-select"
                                placeholder="Conta"
                                maxLength={20}
                                onChange={(e) => {
                                  setFormValues((prevValues) => ({
                                    ...prevValues,
                                    conta: e.target.value,
                                  }));
                                }}
                                value={formValues?.conta || dadoRecebido.conta}
                                name="conta"
                                inputProps={{
                                  minLength: 2,
                                  maxLength: 20,
                                }}
                                error={getErros.includes('Conta')}
                                onBlur={() => {
                                  if (!formValues?.conta && !dadoRecebido.conta) {
                                    setErros((prev) => [...prev, 'Conta']);
                                  } else {
                                    getErros.includes('Conta') &&
                                      setErros(getErros.filter((item) => item !== 'Conta'));
                                  }
                                }}
                              />
                            </Paper>
                          </Grid>
                          <Grid item xs={1}>
                            <S.InputLabel>Dígito</S.InputLabel>
                            <Paper elevation={0} className="input-paper">
                              <Input
                                className="input-select"
                                placeholder="Dígito"
                                maxLength={2}
                                onChange={(e) => {
                                  setFormValues((prevValues) => ({
                                    ...prevValues,
                                    contaDigito: e.target.value,
                                  }));
                                }}
                                value={formValues?.contaDigito}
                                name="contaDigito"
                                inputProps={{
                                  minLength: 1,
                                  maxLength: 2,
                                  style: { textTransform: "uppercase" }
                                }}
                                error={getErros.includes('Conta')}
                                onBlur={() => {
                                  if (!formValues?.contaDigito && !dadoRecebido.contaDigito) {
                                    setErros((prev) => [...prev, 'contaDigito']);
                                  } else {
                                    getErros.includes('contaDigito') &&
                                      setErros(getErros.filter((item) => item !== 'contaDigito'));
                                  }
                                }}
                              />
                            </Paper>
                          </Grid>
                        </Grid>
                      </>
                    )}
                  </>
                ) : (
                  ''
                )}

                {rural === 'false' &&
                  !statusRural[dadoRecebido.gruposFornecedores?.produtorRural] && (
                    <Grid container spacing={2}>
                      {dadoRecebido.gruposFornecedores?.tipoPessoa !== 'Juridica' && (
                        <Grid item xs={4}>
                          <S.InputLabel>CPF</S.InputLabel>
                          <Paper elevation={0} className="input-paper">
                            <InputMask
                              mask="999.999.999-99"
                              value={formValues?.cnpjCpf || dadoRecebido.gruposFornecedores?.raizCnpjCpf}
                              name="cnpjCpf"
                              disabled={dadoRecebido.gruposFornecedores?.raizCnpjCpf}
                              error={getErros.includes('CnpjCpf')}
                              onChange={(e) => {
                                setFormValues((prev) => ({ ...prev, cnpjCpf: e.target.value }));
                              }}
                              onBlur={() => {
                                if (!formValues?.cnpjCpf && !dadoRecebido.gruposFornecedores?.raizCnpjCpf) {
                                  setErros((prev) => [...prev, 'CnpjCpf']);
                                } else {
                                  getErros.includes('CnpjCpf') &&
                                    setErros(getErros.filter((item) => item !== 'CnpjCpf'));
                                }
                              }}
                            >
                              {() => (
                                <Input
                                  placeholder="CPF"
                                  className="input-select"
                                  name="cnpjCpf"
                                  style={{ height: '42px' }}
                                />
                              )}
                            </InputMask>
                          </Paper>
                        </Grid>
                      )}

                      {dadoRecebido.gruposFornecedores?.tipoPessoa === 'Juridica' && (
                        <Grid item xs={8}>
                          <S.InputLabel>CNPJ</S.InputLabel>
                          <S.CNPJBox>
                            <Paper elevation={0} className="input-paper root-cnpj">
                              <InputMask
                                mask="99.999.999/"
                                value={dadoRecebido.gruposFornecedores?.raizCnpjCpf}
                                disabled
                              >
                                {() => (
                                  <Input
                                    disabled
                                    placeholder="CNPJ"
                                    className="input-select"
                                    style={{ height: '42px' }}
                                  />
                                )}
                              </InputMask>
                            </Paper>
                            <Paper elevation={0} className="input-paper filial-cnpj">
                              <InputMask
                                mask="9999-99"
                                name="filialCNPJ"
                                value={formValues?.filialCNPJ || dadoRecebido.cnpjComplemento}
                                disabled={dadoRecebido.cnpjComplemento ? true : false}
                                onChange={(e) => {
                                  setFormValues((prev) => ({ ...prev, filialCNPJ: e.target.value }));
                                }}
                              >
                                {() => (
                                  <Input
                                    className="input-select"
                                    placeholder="CNPJ"
                                    autoFocus
                                    error={getErros.includes('filialCNPJ')}
                                    name="filialCNPJ"
                                    style={{ height: '42px' }}
                                  />
                                )}
                              </InputMask>
                            </Paper>
                          </S.CNPJBox>
                        </Grid>
                      )}
                    </Grid>
                  )}
              </S.ApproveContainer>
            </div>
          </S.InfoContainer>
        )}
        <S.ApproveContainer>
          {dadoRecebido.questionarFornecedoresBoletosEmitidos !== 'Nao' && (
            <S.InfoContainer>
              <S.TableTitleHeader>
                <h1>Boletos Emitidos</h1>
              </S.TableTitleHeader>
              <Grid container style={{ padding: '20px 10px 0px' }}>
                <Grid item sm={12}>
                  <Paper elevation={0}>
                    <FormControl className="message-html">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: dadoRecebido.questionarFornecedoresBoletosEmitidosMensagem,
                        }}
                      />
                      <RadioGroup
                        value={boleto}
                        onChange={(e) => {
                          setBoleto(e.target.value);
                        }}
                        style={{ display: 'flex' }}
                      >
                        <div>
                          <Radio
                            checked={boleto === 'Emitidos'}
                            validaBotaoTeclado
                            value="Emitidos"
                            name="radio-buttons"
                            inputProps={{ 'aria-label': 'B' }}
                          />
                          <span
                            dangerouslySetInnerHTML={{
                              __html: dadoRecebido.questionarFornecedoresBoletosEmitidosOpcao1,
                            }}
                          />
                        </div>
                        <div>
                          <Radio
                            checked={boleto === 'NaoEmitidos'}
                            validaBotaoTeclado
                            value="NaoEmitidos"
                            name="radio-buttons"
                            inputProps={{ 'aria-label': 'B' }}
                          />
                          <span
                            dangerouslySetInnerHTML={{
                              __html: dadoRecebido.questionarFornecedoresBoletosEmitidosOpcao2,
                            }}
                          />
                        </div>
                        {/* <FormControlLabel
                            value="false"
                            control={<Radio />}
                            label={dadoRecebido.questionarFornecedoresBoletosEmitidosOpcao1}
                            />
                          <FormControlLabel
                            value="false"
                            control={<Radio />}
                            label={dadoRecebido.questionarFornecedoresBoletosEmitidosOpcao2} /> */}
                      </RadioGroup>
                    </FormControl>
                  </Paper>
                </Grid>
              </Grid>
            </S.InfoContainer>
          )}
          {dadoRecebido.questionarFornecedoresAceitaAbatimentosDescontos !== 'Nao' && (
            <S.InfoContainer>
              <S.TableTitleHeader>
                <h1>Abatimentos/Descontos</h1>
              </S.TableTitleHeader>
              <Grid container style={{ padding: '20px 10px 0px' }}>
                <Grid item sm={12}>
                  <Paper elevation={0}>
                    <FormControl className="message-html">
                      {dadoRecebido.questionarFornecedorAceitaAbatimentosDescontosMensagem && (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: dadoRecebido.questionarFornecedorAceitaAbatimentosDescontosMensagem,
                          }}
                        />
                      )}
                      <RadioGroup
                        value={abatimentos}
                        onChange={(e) => {
                          setAbatimentos(e.target.value);
                        }}
                        style={{ display: 'flex' }}
                      >
                        <div>
                          <Radio
                            checked={abatimentos === 'Aceita'}
                            validaBotaoTeclado
                            value="Aceita"
                            name="radio-buttons"
                            inputProps={{ 'aria-label': 'B' }}
                          />
                          <span
                            dangerouslySetInnerHTML={{
                              __html: dadoRecebido.questionarFornecedorAceitaAbatimentosDescontosOpcao1,
                            }}
                          />
                        </div>
                        <div>
                          <Radio
                            checked={abatimentos === 'NaoAceita'}
                            validaBotaoTeclado
                            value="NaoAceita"
                            name="radio-buttons"
                            inputProps={{ 'aria-label': 'B' }}
                          />
                          <span
                            dangerouslySetInnerHTML={{
                              __html: dadoRecebido.questionarFornecedorAceitaAbatimentosDescontosOpcao2,
                            }}
                          />
                        </div>
                      </RadioGroup>
                    </FormControl>
                  </Paper>
                </Grid>
              </Grid>
            </S.InfoContainer>
          )}
          <S.InfoContainer style={{ padding: '0px 10px' }}>
            <S.ConfirmationBox>
              {dadoRecebido.solicitarCodigoAutenticacao === true && (
                <>
                  <span className="confirmation-message">Campo para autenticação</span>
                  <ReactCodeInput
                    className="confirmation-box"
                    disabled={boleto === ''}
                    fields={4}
                    onChange={onChange}
                  />
                </>
              )}
              {dadoRecebido.botaoEnviar && (
                <S.ActionButton
                  variant="contained"
                  disabled={isLoading || boleto === ''}
                  onClick={() => submitForm()}
                >
                  {isLoading ? 'Confirmando...' : 'Confirmar'}
                </S.ActionButton>
              )}
            </S.ConfirmationBox>
          </S.InfoContainer>

          {/* ONLY FOR TEST */}
          {/* <S.ConfirmationBox>
          <ReactCodeInput className="confirmation-box" fields={4} onComplete={completeForm} />
          <S.ActionButton variant="contained" onClick={() => submitForm()} disabled={!code}>
            Confirmar
          </S.ActionButton>
        </S.ConfirmationBox> */}
        </S.ApproveContainer>
      </div>
   
  );
};

export default ApproveConclusion;
